<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="primary--text pb-2">Pick your fields</h2>
      <p>Which fields do you want to see in your bucket?</p>
    </v-flex>
    <v-flex xs12>
      <v-layout v-for="(field, i) in bucket.displayFields" :key="i" row>
        <bucket-field
          :field="field"
          :sortDirection="getSortDirection(field)"
          :sortPosition="getSortPosition(field)"
          :schema="schema">
        </bucket-field>
      </v-layout>
      <v-layout row>
        <v-btn
          class="ml-0 mt-0"
          id="addField-btn"
          color="secondary"
          @click="appendDisplayField()">
        Add a New Field</v-btn>
      </v-layout>
    </v-flex>
    <v-flex xs12 mt-4>
      <h2 class="primary--text pb-0">Group by field</h2>
    </v-flex>
    <v-flex
      xs12 sm12
      :class="{'pr-0 pb-4 mt-3': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp}">
        <v-layout row>
          <bucket-field
            :field="kpiField"
            :sortDirection="kpiField.sortDirection"
            :sortPosition="kpiField.sortPosition"
            :schema="schema" hide-sort hide-delete
            v-on:changed-field="changedKpiField"
            v-on:changed-fieldset="changedKpiFieldset"
            >

          </bucket-field>
          <v-switch class="ml-3" id="displayGroupByPanel" v-model="bucket.displayGroupByPanel" style="display:inline-block" label="Display 'Group By' Panel"></v-switch>

        </v-layout>

    </v-flex>
  </v-layout>
</template>

<script>
import BucketField from "@/components/buckets/bucket-edit/Fields/BucketField.vue"

export default {
  name: "BucketFieldsTab",
  data: () => {
    return {
      // kpiField: {
      //   fieldName: "current_state",
      //   fieldset: "common",
      //   sortDirection: "asc",
      //   sortPosition: 0
      // }
      selectedKpiFieldset: undefined,
      selectedKpiField: undefined
    }
  },
  mounted() {
    this.selectedKpiFieldset = this.fieldsetForField(this.bucket.kpi)
    this.selectedKpiField = this.bucket.kpi
  },
  computed: {
    kpiField: {
      get() {
        if (!this.selectedKpiFieldset) {
          return { fieldset: "common", fieldName: "current_state", sortDirection: "asc", sortPosition: 0 }
        }
        const result = { fieldset: this.selectedKpiFieldset, fieldName: this.selectedKpiField, sortDirection: "asc", sortPosition: 0 }
        console.log("KPI FIELD", result)

        return result
      }
    }
  },
  components: { BucketField },
  props: {
    bucket: {
      type: Object,
      required: true
    },
    caseType: {
      type: Object,
      required: true
    },
    schema: {
      type: Object,
      required: true
    }
  },
  methods: {
    fieldsetForField(fieldName) {
      let fieldset
      const fieldsets = this.schema.fieldsets
      for (const fs of fieldsets) {
        for (const field of fs.fields) {
          if (field.name === fieldName) {
            fieldset = fs.name
            break
          }
        }
        if (fieldset) {
          break
        }
      }
      return fieldset
    },
    changedKpiField(newKpiField) {
      console.log(newKpiField)
      this.bucket.kpi = newKpiField.fieldName
      this.selectedKpiField = newKpiField.fieldName
    },
    changedKpiFieldset(newKpiFieldset) {
      console.log(newKpiFieldset)
      this.selectedKpiFieldset = newKpiFieldset
      this.selectedKpiField = undefined
    },
    getSortPosition(df) {
      if (this.bucket && this.bucket.sortFields && this.bucket.sortFields.length > 0) {
        const foundField = this.bucket.sortFields.find(sf => sf.fieldName === df.fieldName)
        if (foundField) {
          return foundField.position
        }
      }
      return 0
    },
    getSortDirection(df) {
      if (this.bucket && this.bucket.sortFields && this.bucket.sortFields.length > 0) {
        const foundField = this.bucket.sortFields.find(sf => sf.fieldName === df.fieldName)
        if (foundField) {
          return foundField.direction
        }
      }
      return "asc"
    },
    appendDisplayField() {
      this.$store.dispatch("addNewDisplayField")
    }
  }
}
</script>
